import { Component, OnInit , OnDestroy , ViewChild , Inject  } from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { MAT_DIALOG_DATA , MatDialog , MatDialogRef  } from '@angular/material/dialog';

@Component({
  selector: 'app-sale-process-detaile',
  templateUrl: './sale-process-detaile.component.html',
  styleUrls: ['./sale-process-detaile.component.css']
})
export class SaleProcessDetaileComponent implements OnInit , OnDestroy {
  public isOnline:any;
  public loading = false;
  public subscription:Subscription;
  public err:string;public err_validation:boolean=false;
  public err_internet_text:string;public err_internet_validation:boolean;
  public server:any;
  user:string;
  lang:any;
  list_user:any=[];
  list_user_select:any=[];
  list_user_selected:any=[];
  arr_users:any=[];
  id:number;
  pattern_title_with_persian:string;
  title:string;

  
  constructor(public serverService:ServerService , public router:Router , public matSnackBar:MatSnackBar
  ,@Inject(MAT_DIALOG_DATA) private dialog_data:any
  ,private matDialogRef:MatDialogRef<SaleProcessDetaileComponent>) { 
   if(dialog_data){
     this.id = this.dialog_data.id;
     this.title = this.dialog_data.title;
   }
  }//end consructor
  
  ngOnInit() {
   this.server = this.serverService.get_server();
   this.serverService.status1(2);
   this.lang = localStorage.getItem("lang");
   this.pattern_title_with_persian = this.serverService.pattern_title_with_persian();
   this.get_selected_users();
  }//

  get_selected_users(){
    if(this.serverService.check_internet()['status'] == false){
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
      return;
    }//end if
  	else{this.matSnackBar.dismiss();}
    this.loading=true;
    this.subscription = this.serverService.post_address(this.server,'new_address',{ 'address' : 66 , id : this.id }).subscribe(  
     (res)=>{
       this.list_user_selected=[];
      if(res['status'] == 1 ){
       for(var i=0;i<res['num'];i++){ 
        this.list_user_selected.push(res['result'][i]);
       }//end for
       this.recieve_erorr(false,"","",1,"","");
      }//end if
      else{
        var pe_message = "خطا در دریافت";
        var pe_action = "بستن";
        this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
      }
     }
    ) 
  }//end get_selected_users



  get_users(){ 
    if(this.serverService.check_internet()['status'] == false){
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
      return;
    }//end if
  	else{this.matSnackBar.dismiss();}
     this.loading=true;
    this.subscription = this.serverService.post_address(this.server,'new_address',{ 'address' : 64 , title : this.user }).subscribe(  
     (res)=>{
       this.list_user=[];
      if(res['status'] == 1 ){
       for(var i=0;i<res['num'];i++){ 
        this.list_user.push(res['result'][i]);
        if(this.list_user_selected.findIndex(x => x.user_id == res['result'][i].user_id) == -1 ){
          this.list_user[i].checked = false;
        }else{
          this.list_user[i].checked = true;
        }
       }//end for
       console.log(this.list_user);
       this.recieve_erorr(false,"","",1,"","");
      }//end if
      else{
        var pe_message = "خطا در دریافت";
        var pe_action = "بستن";
        this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
      }
     }
    ) 
  }//get_users

  
  insert(i,event:any,id,username,title){
    var ckecked=event.checked;
    if(this.serverService.check_internet()['status'] == false){
     var pe_message = "خطا در اینترنت";
     var pe_action = "بستن";
     this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
    return;
   }//end if  
   else{this.matSnackBar.dismiss();}
   this.loading=true;
   this.subscription = this.serverService.post_address(this.server,'new_address',{ 'address' : 67 , id : this.id , user : id , ckecked : ckecked }).subscribe(  
   (res)=>{
    if(res['status'] == 1 ){
      var obj = {
        user_title : title , user_userName : username , user_id : id
      }
      this.list_user[i].checked = ckecked;
      if(ckecked == true){
       this.list_user_selected.push(obj);
      }
      else{
       this.list_user_selected.splice(
        this.list_user_selected.findIndex( x => x.user_id == id ),1);
      }//end else
      this.recieve_erorr(false,"","",1,"","");
    }//end if
    else{
      var pe_message = "خطا در دریافت";
      var pe_action = "بستن";
      this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
    }
   }) 
  }//end insert


  delete(id,username,title){
   if(this.serverService.check_internet()['status'] == false){
    var pe_message = "خطا در اینترنت";
    var pe_action = "بستن";
    this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
    return;
   }//end if
   else{this.matSnackBar.dismiss();}
   this.loading=true;
   this.subscription = this.serverService.post_address(this.server,'new_address',{ 'address' : 67 , id : this.id , user : id , ckecked : false }).subscribe(  
   (res)=>{
    if(res['status'] == 1 ){
       this.list_user_selected.splice(this.list_user_selected.findIndex( x => x.user_id == id ),1);
       if( this.list_user[ this.list_user.findIndex( x => x.user_id == id )]) {
         this.list_user[ this.list_user.findIndex( x => x.user_id == id )  ].checked = false;
       }
       this.recieve_erorr(false,"","",1,"","");
    }//end if
    else{
      var pe_message = "خطا در دریافت";
      var pe_action = "بستن";
      this.recieve_erorr(true,'Erorr in recieve',pe_message,1,'close',pe_action);
    }
   }) 
  }//end delete

  close(){
    this.matDialogRef.close();
  }
  
  //**************************************************
  recieve_erorr(validation,en_message,pe_message,type,en_action,pe_action){
    this.err_internet_validation=false;
    if(type == 1) this.loading=false; 
    if(validation == true ) {
       if(this.lang == 1) this.matSnackBar.open(pe_message,pe_action,{ duration : 2000 });
       if(this.lang == 2) this.matSnackBar.open(en_message,en_action,{ duration : 2000 });
    }//end if
    else{
       this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy():void{
   if(this.subscription){
    this.subscription.unsubscribe();
   }//end if
  }//end OnDestroy
}


